import QcBom from './QcBom/QcBom';
import QcIngredient from './QcIngredient/QcIngredient';
import QcGoods from './QcGoods/QcGoods';

export const Qc = {
    QcBom
    , QcIngredient
    , QcGoods
}